import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/src/app/(pages)/layout.tsx");
